var $4c9dcf87f189563f$exports = {};
$4c9dcf87f189563f$exports = {
    "backButton": (args)=>`Povratak na ${args.prevMenuButton}`,
    "moreActions": `Dodatne radnje`,
    "unavailable": `Nije dostupno, pro\u{161}iri za detalje`
};


export {$4c9dcf87f189563f$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
